import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import { futureDateWithTodayValidation } from "@validations/utils";

export const RELEASE = FORM_FIELDS.RELEASE;
export const BASIC_INFO = RELEASE.BASIC_INFO;
export const SUPPORTING_DOCUMENT = RELEASE.SUPPORTING_DOCUMENT;
export const MODAL = RELEASE.MODAL;

export const releaseFormValidation = yup.object().shape({
  [BASIC_INFO.RELEASE_DATE]: yup.string().required("Release date is required"),
  // [SUPPORTING_DOCUMENT]: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       id: yup.number(),
  //       name: yup.string(),
  //       mimeType: yup.string(),
  //       fileId: yup.string(),
  //       documentId: yup.string(),
  //       documentType: yup.string(),
  //     }),
  //   )
  //   .required("Document is required"),
});

export type ReleaseFormDataType = yup.InferType<typeof releaseFormValidation>;
